// Components that `modal-trigger` can open, keyed by its `url` prop.
//
// This is a static list on purpose. Resolving the prop with
// import(`@app/${url}`) made webpack put a map of every file under
// components/ into the main bundle (1 500 entries, 77 KB) and emit a separate
// chunk for each of them. Add a line here when a template passes a new `url`.
export default {
  'Auth/Login': () => import('@app/Auth/Login'),
  'Auth/PasswordChange': () => import('@app/Auth/PasswordChange'),
  'Auth/Recovery': () => import('@app/Auth/Recovery'),
  'Auth/Register': () => import('@app/Auth/Register'),
  'Buyer/User/Parts/DeactivateUser': () => import('@app/Buyer/User/Parts/DeactivateUser'),
  'Buyer/User/Parts/EmailChange': () => import('@app/Buyer/User/Parts/EmailChange'),
  'Buyer/User/Parts/PhoneChange': () => import('@app/Buyer/User/Parts/PhoneChange'),
  'Forms/ModalShopInformation': () => import('@app/Forms/ModalShopInformation'),
  'Forms/ModalShopInformationBack': () => import('@app/Forms/ModalShopInformationBack'),
  'Forms/ModalShopInformationContact': () => import('@app/Forms/ModalShopInformationContact'),
  'Forms/ModalShopInformationGuarantee': () => import('@app/Forms/ModalShopInformationGuarantee'),
  'Forms/ModalShopInformationSmall': () => import('@app/Forms/ModalShopInformationSmall'),
  'Forms/ModalShopSchedule': () => import('@app/Forms/ModalShopSchedule'),
  'Forms/ModalWrapper': () => import('@app/Forms/ModalWrapper'),
  'Order/Steps/Parts/NewPostList': () => import('@app/Order/Steps/Parts/NewPostList'),
  'Order/Steps/Parts/WarehousesList': () => import('@app/Order/Steps/Parts/WarehousesList'),
  'Review/Add': () => import('@app/Review/Add'),
  'Review/AddClaim': () => import('@app/Review/AddClaim'),
  'Review/ShopAdd': () => import('@app/Review/ShopAdd'),
  'Seller/Modules/Novaposhta/Waybills': () => import('@app/Seller/Modules/Novaposhta/Waybills'),
  'Seller/Pickup/Add': () => import('@app/Seller/Pickup/Add'),
  'UiElements/NotPermission': () => import('@app/UiElements/NotPermission'),
  'UiElements/SpecialInformation': () => import('@app/UiElements/SpecialInformation'),
}
